import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mega-menu" }
const _hoisted_2 = {
  key: 0,
  class: "mega-menu__skeletons"
}
const _hoisted_3 = ["data-text", "href"]
const _hoisted_4 = ["data-text", "onClick"]
const _hoisted_5 = {
  key: 2,
  class: "menu-dropdown"
}
const _hoisted_6 = { class: "menu-dropdown-content" }
const _hoisted_7 = { class: "mega-menu-ul-level2" }
const _hoisted_8 = {
  key: 0,
  class: "separator-level2"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "mega-menu-ul-level3" }
const _hoisted_13 = {
  key: 0,
  class: "separator-level3"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 2 }

import { computed, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { IMegaMenuActiveItemOverwrite, IMegaMenuItem } from '@/types/megaMenuTypes';
import { useNavigationStore } from '@/stores/navigation.store';
import { Skeleton } from '@progress/kendo-vue-indicators';
import useMenu from '@/composables/useMenu';

import { useMagicKeys, whenever } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'MegaMenu',
  props: {
  megaMenuItems: {
    type: Array<IMegaMenuItem>,
    required: true,
  },
  activeMegaMenuItemOverwrite: {
    type: Object as () => IMegaMenuActiveItemOverwrite,
    required: false,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;

const navigationStore = useNavigationStore();
const megaMenu = ref(null);
const keys = useMagicKeys();
const { getPathMatchWeight } = useMenu();

onClickOutside(megaMenu, () => handleMouseOutsideMenu());

function handleOpenMenu(elementIndex: number) {
  if (navigationStore.userTopMenu.menuItemViewModels) {
    navigationStore.userTopMenu.menuItemViewModels.forEach((item, index) => {
      item.isOpen = index === elementIndex ? !item.isOpen : false;
    });
  }
}

function closeAllMenus() {
  navigationStore.userTopMenu.menuItemViewModels?.forEach((element) => {
    element.isOpen = false;
  });
}

function handleMouseOutsideMenu() {
  closeAllMenus();
}

const activeItemLevel1 = computed(() => {
  let bestMatch: IMegaMenuItem | null = null;
  let highestWeight = 0;

  for (const item of props.megaMenuItems) {
    const weight = getPathMatchWeight(item, props.activeMegaMenuItemOverwrite);
    if (weight && weight > highestWeight) {
      highestWeight = weight;
      bestMatch = item;
    }
  }

  return bestMatch;
});

whenever(keys.escape, () => {
  closeAllMenus();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (props.megaMenuItems?.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (skeletonElement, skeletonsIndex) => {
            return _createVNode(_unref(Skeleton), {
              key: skeletonsIndex,
              animation: { type: 'pulse' },
              shape: 'rectangle'
            })
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("ul", {
          key: 1,
          ref_key: "megaMenu",
          ref: megaMenu,
          class: "mega-menu-ul-level1",
          role: "menubar"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.megaMenuItems, (itemLevel1, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass([{ open: itemLevel1?.isOpen, separator: itemLevel1?.isSeparator }, "mega-menu-li-level1"]),
              role: "none"
            }, [
              (itemLevel1?.hasUrl && !itemLevel1?.hasItems)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    "data-text": itemLevel1?.translation,
                    href: itemLevel1.href,
                    role: "menuitem"
                  }, _toDisplayString(itemLevel1?.translation), 9, _hoisted_3))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: _normalizeClass({ active: itemLevel1 == activeItemLevel1.value }),
                    "data-text": itemLevel1?.translation,
                    href: '#',
                    role: "menuitem",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                    onClick: _withModifiers(($event: any) => (handleOpenMenu(index)), ["prevent"])
                  }, _toDisplayString(itemLevel1?.translation), 11, _hoisted_4)),
              (itemLevel1?.hasItems)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemLevel1?.items, (itemLevel2, index2) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index2,
                            class: "mega-menu-li-level2",
                            role: "none",
                            tabindex: "-1"
                          }, [
                            (itemLevel2?.isSeparator)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_8))
                              : (itemLevel2?.hasUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: itemLevel2?.href,
                                    role: "menuitem"
                                  }, _toDisplayString(itemLevel2?.translation), 9, _hoisted_9))
                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(itemLevel2?.translation), 1)),
                            (itemLevel2?.hasItems)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("ul", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemLevel2?.items, (itemLevel3, index3) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index3,
                                        class: "mega-menu-li-level3",
                                        role: "none"
                                      }, [
                                        (itemLevel3?.isSeparator)
                                          ? (_openBlock(), _createElementBlock("hr", _hoisted_13))
                                          : (itemLevel3?.hasUrl)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                href: itemLevel3?.href,
                                                role: "menuitem"
                                              }, _toDisplayString(itemLevel3?.translation), 9, _hoisted_14))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(itemLevel3?.translation), 1))
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 512))
  ]))
}
}

})